import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthorizedUser, UserStorage, UserNotificationComponent } from '@scisys-uim/uim-common';
import { SystemMessageDialogComponent } from '../../domain/systemmessage/dialog/system-message-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.css']
})
export class HeaderMenuComponent implements OnInit {

  
  @ViewChild(UserNotificationComponent)
  private userNotificationComponent: UserNotificationComponent;

  constructor(private userStorage: UserStorage,
    private dialog: MatDialog) { }

  ngOnInit() {
  }

  get user(): AuthorizedUser {
    return this.userStorage.get();
  }

  systemMessagePopupEnabled() {
    return this.userStorage.currentUserHasAnyAuthority(['WRITE_SYSTEM_MESSAGE']);
  }

  openSystemMessagePopup() {
    var ref = this.dialog.open(SystemMessageDialogComponent, {
      panelClass: 'dialog-resizable',
      height: '600px',
      width: '900px',
      data: {
      }
    })
    ref.afterClosed().subscribe(
      result => { this.userNotificationComponent?.loadNotifications(); }
    );
  }

}
